
import React from 'react';
import { GameState } from '../types';

interface KeypadProps {
  gameState: GameState;
  onInput: (num: number) => void;
  onToggleNote: () => void;
  onUndo: () => void;
  isMobile?: boolean;
}

const Keypad: React.FC<KeypadProps> = ({ gameState, onInput, onToggleNote, onUndo, isMobile }) => {
  return (
    <div className={`flex flex-wrap gap-1 md:gap-2 justify-center p-2 md:p-3 balatro-gradient rounded-xl md:rounded-2xl border border-white/5 shadow-2xl ${isMobile ? 'w-full' : 'grid grid-cols-3'}`}>
      {[1,2,3,4,5,6,7,8,9].map(n => (
        <button key={n} onClick={() => onInput(n)} className="w-8 h-8 md:w-11 md:h-11 bg-white/5 hover:bg-[#ff0040] hover:text-white rounded-lg font-black text-sm md:text-xl transition-all active:scale-90">{n}</button>
      ))}
      <div className={`w-full flex gap-1 mt-1 ${isMobile ? 'justify-center' : 'col-span-3'}`}>
        <button onClick={onToggleNote} className={`flex-1 py-1.5 rounded-lg font-bold text-[8px] md:text-[10px] uppercase tracking-widest border transition-all ${gameState.noteMode ? 'bg-blue-600 border-blue-500 text-white' : 'border-white/10 text-gray-500'}`}>Note</button>
        <button onClick={onUndo} disabled={!gameState.history.length} className="flex-1 py-1.5 rounded-lg font-bold text-[8px] md:text-[10px] uppercase tracking-widest border border-white/10 text-gray-500 disabled:opacity-20">Undo</button>
      </div>
    </div>
  );
};

export default Keypad;
